import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { Clock, X, Zap } from 'lucide-react'
import { useState } from 'react'
import styles from './TrialBanner.module.css'

export default function TrialBanner() {
  const { profile } = useAuth()
  const navigate = useNavigate()
  const [dismissed, setDismissed] = useState(false)

  if (!profile || dismissed) return null

  const { subscription_status, trial_ends_at } = profile

  // Only show for trialing users
  if (subscription_status !== 'trialing') return null

  // Calculate days remaining
  const now = new Date()
  const trialEnd = trial_ends_at ? new Date(trial_ends_at) : null
  if (!trialEnd) return null

  const msRemaining = trialEnd - now
  const daysRemaining = Math.ceil(msRemaining / (1000 * 60 * 60 * 24))

  // Trial already expired — PaywallGate handles this
  if (daysRemaining <= 0) return null

  // Color based on urgency
  let variant = 'green'
  if (daysRemaining <= 3) variant = 'red'
  else if (daysRemaining <= 7) variant = 'yellow'

  const message = daysRemaining === 1
    ? 'Your free trial ends tomorrow'
    : `${daysRemaining} days left in your free trial`

  return (
    <div className={[styles.banner, styles[variant]].join(' ')}>
      <div className={styles.left}>
        <Clock size={15} />
        <span>{message}</span>
      </div>
      <div className={styles.right}>
        <button className={styles.upgradeBtn} onClick={() => navigate('/settings?tab=billing')}>
          <Zap size={13} />
          Upgrade Now
        </button>
        <button className={styles.dismissBtn} onClick={() => setDismissed(true)}>
          <X size={15} />
        </button>
      </div>
    </div>
  )
}